import { render, staticRenderFns } from "./CreateEdit.vue?vue&type=template&id=2c354b18&scoped=true&"
import script from "./CreateEdit.vue?vue&type=script&lang=js&"
export * from "./CreateEdit.vue?vue&type=script&lang=js&"
import style0 from "./CreateEdit.vue?vue&type=style&index=0&id=2c354b18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.6_fb85a9817f99bdf862e5e3a442a1fb91/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c354b18",
  null
  
)

export default component.exports